import { Icon } from '../../shared';
import React from 'react';
import { CardHeader } from '../../shared/card/card-header';
import './card-error-handling.scss';
export var CardErrorHandlingHeader = function (_a) {
    var icon = _a.icon;
    return (React.createElement(CardHeader, null,
        React.createElement("header", { className: "c-card-bad-redirects__header" },
            React.createElement("div", { className: "c-card-bad-redirects__header__top" },
                React.createElement("div", { className: "c-card__header__avatar" },
                    React.createElement("div", { className: "c-card__header__avatar__image" },
                        React.createElement(Icon, { name: icon !== null && icon !== void 0 ? icon : 'applicants' })))))));
};
